import { type TDS_LOCALES, TDS_DEFAULT_LOCALE } from '../../tds'

/**
 * This is a mapping of the locales that we support in the app.
 * It is used to ensure that the locale is one of the supported ones.
 * Every IPP locale should be a supported TDS locale.
 */
export type IPP_SUPPORTED_LOCALE = TDS_LOCALES

export const IPP_DEFAULT_LOCALE = TDS_DEFAULT_LOCALE
export const IPP_SUPPORTED_LOCALES = ['en-US', 'es-ES', 'fr-FR']
